/**
 * Extend jQuery with some useful helper functions
 */
define('core/polyfills/jQuery',[
	'jquery'
], function ($) {
	'use strict';

	// $.fn.hasAttr = function(attributeName) {
	// 	return this.attr(attributeName) !== undefined;
	// };

	$.pointerTouchPosXY = function(event) {
		var pos = {
			x: 0,
			y: 0,
		};

		try {
			pos.x = event.pageX || event.originalEvent.touches[0].pageX;
		}
		catch (ex) {}
		try {
			pos.y = event.pageY || event.originalEvent.touches[0].pageY;
		}
		catch (ex) {}

		return pos;
	};

	/*!
	 * Regex Selector for jQuery
	 *
	 * @see http://james.padolsey.com/javascript/regex-selector-for-jquery/
	 */
	$.expr[':'].regex = function(elem, index, match) {
		var matchParams = match[3].split(','),
			validLabels = /^(data|css):/,
			attr = {
				method: matchParams[0].match(validLabels) ?
					matchParams[0].split(':')[0] : 'attr',
				property: matchParams.shift().replace(validLabels,'')
			},
			regexFlags = 'ig',
			regex = new RegExp(matchParams.join('').replace(/^s+|s+$/g,''), regexFlags);
		return regex.test(jQuery(elem)[attr.method](attr.property));
	};


	// Force numbers for input[type="number"] elements.
	// Otherwise the user can input '1e-2'.
	// If you want to enable this add `data-dont-force-number="true"` to the element
	$('input[type="number"]').not('[data-dont-force-number]').on('input change', function(event) {
		var $this = $(this),
			numberValue = Number($this.val())
		;
		$this.val(numberValue);
	});



	// // Based on Andrew Marc Newton's work
	// // http://stackoverflow.com/a/19643311/5649903
	// $.fn.serializeObject = function() {
	// 	var data = {};
	// 	$.each(this.serializeArray(), function(key, obj) {
	// 		var a = obj.name.match(/(.*?)\[(.*?)\]/);
	// 		if (a !== null) {
	// 			var subName = "" + a[1];
	// 			var subKey = "" + a[2];
	// 			if (! data[subName]) {
	// 				data[subName] = {};
	// 			}
	// 			if (data[subName][subKey]) {
	// 				if (! $.isArray(data[subName][subKey])) {
	// 					data[subName][subKey] = {};
	// 				}
	// 				data[subName][subKey].push( obj.value );
	// 			} else {
	// 				data[subName][subKey] = obj.value;
	// 			}
	// 		} else {
	// 			var keyName = "" + obj.name;
	// 			if (data[keyName]) {
	// 				if (! $.isArray(data[keyName])) {
	// 					data[keyName] = {};
	// 				}
	// 				data[keyName].push(obj.value);
	// 			} else {
	// 				data[keyName] = obj.value;
	// 			}
	// 		}
	// 	});
	// 	return data;
	// };

});

